import { createFileRoute } from '@tanstack/react-router'

import { ProcessorsScreen } from './-components/processors-screen.tsx'

export const Route = createFileRoute('/merchants/processors')({
  component: ProcessorsScreen
})
